/* file description */
import { cloneDeep, isArray } from 'lodash';
import { jsonataFactory } from '@/utils';

export const listPageRuleFilter = ({ rowBtns, record, rowFreeBtns, listProps }) => {
  if (!isArray(listProps?.rulePageValue) || listProps?.rulePageValue?.length === 0) {
    return {
      changeRowBtns: rowBtns,
      changeFreeBtns: rowFreeBtns,
    };
  }

  const clRowBtns: string[] = cloneDeep(rowBtns);
  const clRowFreeBtns: string[] = cloneDeep(rowFreeBtns);
  const values = Object.assign(cloneDeep(record) || {}, { RECORD: null, toJSON: null });
  const dataSource = {
    [listProps.recordInfo.moduleLabel]: values,
  };

  listProps?.rulePageValue?.forEach((rule) => {
    if (!rule?.rules?.rules_expression) return;
    const expression = jsonataFactory(rule?.rules?.rules_expression);
    const resultTag = expression.evaluate(dataSource);
    // for (const [key, isShow] of Object.entries(rule.events?.btnConfig?.['list-row'] || {})) {
    //   // 按钮显示的条件不成立 或 按钮不显示的条件成立 需要隐藏按钮
    //   if ((isShow && !resultTag) || (!isShow && resultTag)) {
    //     clRowBtns = clRowBtns.filter(k => k !== key);
    //   }
    // }
    // for (const [key, isShow] of Object.entries(rule.events?.btnConfig?.free || {})) {
    //   // 按钮显示的条件不成立 或 按钮不显示的条件成立 需要隐藏按钮
    //   if ((isShow && !resultTag) || (!isShow && resultTag)) {
    //     clRowFreeBtns = clRowFreeBtns.filter(k => k !== key);
    //   }
    // }
    if (!resultTag) return;
    for (const [key, value] of Object.entries(rule.events?.btnConfig?.['list-row'] || {})) {
      if (!value) continue;
      const targetBtn = clRowBtns.findIndex((item) => item == key);
      if (targetBtn < 0) {
        clRowBtns.push(key);
      }
    }
    for (const [key, value] of Object.entries(rule.events?.btnConfig?.free || {})) {
      if (!value) continue;

      const targetBtn = clRowFreeBtns.findIndex((item: any) => {
        return item.text == key;
      });
      if (targetBtn < 0) {
        clRowBtns.push(key);
      }
    }
  });

  return {
    changeRowBtns: clRowBtns,
    changeFreeBtns: clRowFreeBtns,
  };
};
